module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="box" id="' +
((__t = ( id )) == null ? '' : __t) +
'">\n	';
if(currentAlbum.campaign){ ;
__p += '\n		<a class="share_panel_button_w_vote"></a>\n	';
};
__p += '\n		';
 if (isVideo()) {;
__p += '\n			<a class="layer_video lightboxed" id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'" rel=\'album\' href="' +
((__t = ( thumbnail() )) == null ? '' : __t) +
'">\n				<div class="play_button"></div>\n				<div class="cover"></div>\n			</a>\n		';
};
__p += '\n		<div class="layer_photo_caption">\n			<a class="grouped_elements img_holder image_anchor ';
 if (!isVideo()) {;
__p += 'lightboxed ';
};
__p += '" id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'" ';
 if (!isVideo()) {;
__p += 'href="' +
((__t = ( photoURL('xl') )) == null ? '' : __t) +
'" rel=\'album\'';
};
__p += '>\n				\n				<div class="box_bg_image" style="background-image: url(&quot;' +
((__t = ( thumbnail('medium') )) == null ? '' : __t) +
'&quot;);" ></div>\n				<img class="box_image" style="display:none;" src="' +
((__t = ( thumbnail('medium') )) == null ? '' : __t) +
'" />\n			</a>\n			';
 if(!voted()){ ;
__p += '<div class="vote_container">';
 };
__p += '\n			';
 if(voted()){ ;
__p += '<div class="vote_container voted">';
 };
__p += '\n					<div class="vote_button"><svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\nwidth="160px" height="30px" viewBox="0 0 160 30" enable-background="new 0 0 160 30" xml:space="preserve"><path d="M1.729,29.969c0,0,2.312,0.125,4.062-2l20.75-25.312c0,0,1.781-2.312,4.781-2.312h97.062\nc0,0,2.72,0,4.828,2.688l19.531,24.266c0,0,1.969,2.688,4.547,2.703l0,0l0,0l0,0l0,0l0,0l0,0L1.729,29.969z"/>';
 if(!voted()){ ;
__p += '<span class="vote_text">' +
((__t = ( decode_utf8(getVoteShareText()) )) == null ? '' : __t);
 if(displayOptions.showVoteCount  &&  currentAlbum.campaign){ ;
__p += '<span class="vote_counter">';
 if(like_count != null && like_count != "null" && like_count){ ;
__p += ': ' +
((__t = ( like_count  )) == null ? '' : __t) +
'</span>\n						';
 };
__p += '\n						';
 };
__p += '\n						</span>';
 };
__p += '\n						';
 if(voted()){ ;
__p += '<span class="vote_text">Voted</span>';
 };
__p += '\n						</svg>\n					</div>\n				</div>\n				\n					<div class="caption">\n						<div class="caption-wrapper"><span>' +
((__t = ( submitterAnchor(true) )) == null ? '' : __t) +
'</span>';
 if (shouldShowCaptions()){;
__p += '\n							<div class="item_caption_text text"> ';
 if (getTitle() != ""){;
__p +=
__e(  decode_utf8(getTitle()) ) +
' ';
 };
__p += '</div> \n							';
 if (showDate()){;
__p += '<i>' +
((__t = (  getDate() )) == null ? '' : __t) +
'</i>';
 };
__p += '\n						';
 };
__p += '</div>\n					</div>\n				\n		</div>\n		<div class="layer_share">\n			<div class="close_share_button"></div>\n			<div class="pixlee_share">\n				<span>Share this photo</span>\n				<div class="pixlee_fshare"></div>\n				<div class="pixlee_tweet"></div>\n				<div class="pixlee_pinit"></div>\n				<div class="pixlee_tumblr"></div>\n			</div>\n		</div>\n	</div>';

}
return __p
}